/* eslint-disable react/no-danger */
import { Col, Container, Row } from 'reactstrap';

export default function TandCJp() {
  return (
    <section className="content-page-wrapper">
      <Container>
        <Row>
          <Col xl={{ size: 8, order: 2, offset: 2 }}>
            <h1>利用規約</h1>
            <p>
              この利用規約（以下「本規約」といいます）をよくお読みください。本規約は、お客様（以下「お客様」といいます）と日本の法律に基づいて設立された株式会社 Zenyum Japan（以下、「当社」）
              およびその子会社、関連会社、関連法人(これらをあわせて「当社」と表現していることがあります。)との間で締結される法的拘束力のある契約の内容になります。本ウェブサイト
              （以下に定義）またはその一部にアクセスまたは使用することにより、お客様は本規約およびプライバシーポリシー
              （アクセス先：
              <a href="https://www.zenyum.com/jp-ja/privacy">https://www.zenyum.com/jp-ja/privacy</a>
              ）
              に拘束されることを受け入れ、同意したものとします。
              お客様は、プライバシーポリシーをお読みになり、個人情報保護法に基づき、当社がどのようにお客様の個人情報を収集、使用、開示、処理、保護するかをご確認ください。
            </p>
            <br />
            <p>本規約に同意されない場合は、直ちに本ウェブサイトへのアクセスまたは使用を中止してください。</p>
            <br />
            <p>本規約において、「本サービス」とは、以下のものによって、またはこれらを通じて提供されるあらゆるサービスを含みます。</p>
            <ul>
              <li>    zenyum Japan を含む、当社が所有・運営するウェブサイト（以下「本ウェブサイト」といいます。）</li>
              <li>
                当社が任意のソーシャルメディアプラットフォーム(Facebook、Instagram、Twitter、LinkedIn、YouTube、
                および LINE を含むがこれらに限定されない)上に作成した公式ソーシャルメディアチャンネル(以下「本チャンネル」という。)
              </li>
              <li>  当社が提供、運営、所有する、現在提供されている、または将来提供される予定の他のすべてのアプリケーション、サービスおよび/または製品。</li>
              <li>  当社が提供する、あるいは本ウェブサイトや本チャンネルを通じて入手可能な情報、資料、ソフトウェア、製品、サービス、コンテンツ（リンクされた情報を含む）。</li>
              <li>  本ウェブサイトおよび本チャンネルに掲載されているアートワーク、写真、ビデオ、オーディオコンテンツ、および</li>
              <li>
                前述の各項目を更新したもの。
              </li>
            </ul>
            <br />
            <p>（規約の変更）</p>
            <p>
              当社は、いつでも、いかなる理由でも、この規約に含まれる条項を変更、修正、追加、削除する権利を有します。そのような変更の通知は、変更の内容によって効力発生日以前の合理的期間をもって、
              本ウェブサイトおよび/または本チャンネルに掲載し（アクセスは次の URL から可能です：
              <a href="http://zenyum.com/jp-ja/website-terms-and-conditions">
                www.zenyum.com/jp-ja/website-terms-and-conditions
              </a>
              、
              それに伴い規約の左上に表示されている「改定日」の日付も変更されます)、または当社の独自の判断により、その他の方法で書面による通知を行います。
            </p>
            <p>
              お客様は、当社が本規約の変更を掲示した後に、当社のサービスへのアクセスまたは利用を継続することにより、当該変更された規約に明示的に同意したものとみなされます。
              お客様が当該変更後の規約に同意されない場合、お客様は直ちに本サービスへのアクセスまたは使用を中止しなければ
              なりません。ただし、法律によってお客様の同意が必要とされる場合には、お客様の同意を得て変更が有効になるものとします。
            </p>
            <ol>
              <li>
                ウェブサイトの使用およびアクセスの資格
                <ul>
                  <li>  本サービスにアクセスまたは使用することにより、お客様は以下のことを表明し、保証するものとします。</li>
                  <li>  お客様が居住する国の法律によって、本規約に従って本サービスにアクセスまたは使用することが禁止されていないこと。</li>
                  <li>
                    お客様が未成年者ではないこと、すなわち、18 歳以上であること、または、お客様が居住する国の法律でお客様が本サービスに合法的にアクセスまたは使用するために必要とされる年齢のうち、
                    いずれか高い方の年齢であること。
                  </li>
                  <li>
                    未成年者を代理して登録する場合は、当該者を代理して行動する権限を有し、かつ、未成年者の親または法定後見人でなければなりません）。)
                    また、お客様は、本規約を承諾し、(i)未成年者の行為、(ii)未成年者の本サービスの利用に伴う料金、(iii)お客様の本規約の承諾および遵守について責任を負うことに同意します。
                  </li>
                  <li>
                    お客様は、本規約に基づいてのみ本サービスを利用することができます。お客様は、直接的または間接的に（他者を援助または激励することにより）以下の行為を行ってはなりません。
                    ・適用される法律または規制に違反すること。
                  </li>
                </ul>
              </li>
              <li>
                許可された目的
                <ul>
                  <li>
                    当社は、当社が開発した「Zenyum Invisible Braces」（透明な歯列矯正具）および関連製品を、日本で開業登録（必要な届出等の手続を含む）されている歯科医師、
                    またはその他の第三者のサービスプロバイダーと協力して、歯列矯正に特化した治療（以下、総称して「Zenyum 治療」といいます）を提供します。
                  </li>
                  <li>
                    お客様は、本規約に基づいてのみ本サービスを利用することができます。お客様は、直接的に、または間接的に（他の当事者を援助または激励することにより）、以下の行為をしてはなりません。
                    <p className="pl-3">適用される法律または規制に違反すること。</p>
                    <p className="pl-3">本規約に違反すること。</p>
                    <p className="pl-3">本サービスの一部または全部をコピー、フレーム、ミラーリングすること。</p>
                    <p className="pl-3">本サービスの販売、レンタル、リース、その他本サービスを利用する権利の譲渡、または</p>
                    <p className="pl-3">本サービスの質権設定、抵当権設定、先取特権設定、担保権設定を行うこと。</p>
                    <p className="pl-3">
                      本サービスを使用して、お客様が所有していない、またはお客様に提供されていない情報を、そのような使用またはアクセスに対する明示的な許可なく、
                      処理、保存、または取り扱うこと。
                    </p>
                    <p className="pl-3">当社が所有または運営するもの以外の自動化されたアプリケーション、プラットフォーム、プログラムを使用して本サービスにアクセスすること。</p>
                    <p className="pl-3">
                      直接または間接を問わず、本サービスのコピー、翻訳、適応、修正、変更、逆コンパイル、逆アセンブル、その他のリバースエンジニアリングを行うこと、本サービスの二次的著作
                      物を作成すること、本サービスまたはその一部を他のアプリケーションと統合すること、または本サービスの全部または一部を変更すること。
                    </p>
                    <p className="pl-3">本サービスに付されている著作権その他の知的財産権に関するマークや通知を変更または削除すること。</p>
                    <p className="pl-3">本サービスに対するサービス妨害攻撃または類似の行為を行うこと。</p>
                    <p className="pl-3">
                      当社の書面による同意なしに、スクレイピング、スパイダリング、クローリング、
                      またはその他の技術やソフトウェアを使用してデータにアクセスしたり収集したりすること。
                    </p>
                    <p className="pl-3">
                      本サービスを利用して、以下のような投稿、送信または配信を行うこと。(i) 未承諾の電子メール、商品やサービスの広告や宣伝、
                      (ii) 悪意のあるソフトウェアやコード、(iii) 違法、嫌がらせ、プライバシー侵害、虐待、脅迫、下品、わいせつ、人種差別的、または潜在的に有害なコンテンツ、
                      (iv) 第三者の権利や知的財産を侵害するコンテンツ、(v) 第三者に損害を与える可能性のあるコンテンツ、および/または (vi) 犯罪行為を構成、誘発、または助長する、
                      または適用される法律に違反する可能性のあるコンテンツ。
                    </p>
                    <p className="pl-3">本サービスを違法、攻撃的、不道徳または非倫理的な目的で使用すること。</p>
                  </li>
                  <li>
                    本ウェブサイトは、日本在住のお客様を対象としています。あなたが日本以外の国のユーザーで、本サービスを利用したり、当社にユーザーコンテンツを提供したりする場合、
                    あなたは、本ウェブサイトおよび本チャンネル、オンライン上の行為、許容されるユーザーコンテンツに適用されるすべての法律を遵守することに同意するものとします。
                    さらに、お客様は、日本またはお客様が居住する国から輸出されるデータの送信に関するすべての適用法に同意し、これを遵守することに同意するものとします。
                  </li>
                </ul>
              </li>
              <li>
                医療に関する免責事項
                <ul>
                  <li>
                    本サービスを通じて、または本サービス内で提供されるすべての情報、データおよび資料（歯科、医療および健康状態、製品および治療に関連する情報を含む）
                    は、情報提供のみを目的として提供されるものであり、いかなる種類の医療上のアドバイス、推奨または保証を構成するものではありません。提供される情報は、網羅的なものではなく、
                    すべての病気、体調、治療を網羅しているわけではないため、完全なものとはみなされません。提供された情報は、適切な医療専門家の助言や、製品のパッケージやラベルに含まれる情報に代わるものではありません。
                  </li>
                  <li>当社は、お客様が本サービスを利用したことによって、そのような歯科、医療、健康の専門家から提供された助言、相談、サービスについて、いかなる責任も負いません。</li>
                  <li>
                    お客様は、当社が提供する情報、またはお客様による本サービスのご利用を通じて表示される情報を、お客様ご自身の責任において信頼するものとします。
                    歯科、医療、健康に関するご質問がある場合は、速やかに歯科医、医師、または健康専門家にご相談ください。お客様は、本サービスを通じて当社が提供した情報を理由に、
                    歯科または医療上のアドバイスを無視したり、歯科または医療上のアドバイスを求めるのを遅らせたりしてはいけません。また、本サービスを歯科、医療または健康上の問題の診断または治療、
                    あるいは薬の処方に使用してはいけません。本サービスの利用またはお客様と当社との間のコミュニケーションは、お客様と当社との間に歯科医師と患者の関係、医師と患者の関係、
                    その他の信認関係を構成または創出するものではありません。
                  </li>
                </ul>
              </li>
              <li>
                ユーザーアカウント
                <ul>
                  <li>
                    本サービスの一部にアクセスして利用するために（例：お客様が患者である場合：アクセス状況の確認、Zenyum 治療の支払い明細等の閲覧・管理）、
                    お客様（以下「ユーザー」といいます）は、当社のアカウント（以下「ユーザーアカウント」といいます）を作成する必要があります。
                  </li>
                  <li>
                    ユーザーは以下のことに同意します。
                    <p className="pl-2">(a) ユーザーアカウントの作成または更新時に、正確、最新かつ完全な情報を提供すること。</p>
                    <p className="pl-2">(b) ユーザーアカウントの情報を維持し、速やかに更新すること。</p>
                    <p className="pl-2">(c) ログイン認証情報のセキュリティと機密性を維持し、ユーザーアカウントおよび自分のコンピュータへのアクセスを制限すること。</p>
                    <p className="pl-2">(d) 本サービスに関連するセキュリティ違反を発見した場合、または疑わしい場合は、速やかに当社に通知すること。</p>
                    <p className="pl-2">(e) ユーザーアカウントの下で行われるすべての活動に責任を負い、不正アクセスのリスクをすべて受け入れること。</p>
                  </li>
                  <li>
                    アカウントのセキュリティ
                    <p>
                      お客様は、ユーザーアカウントの一部として、または本サービスの利用を通じて、ユーザー名およびパスワード（またはその他の認証手段、
                      もしくは当社が提供するデータ、情報およびサービスへのアクセスを制御するための手段）（以下「アクセスコード」といいます）を受け取ることができます。
                    </p>
                    <p>
                      お客様は、アクセスコードの機密性を維持し、お客様のユーザーアカウントおよび本サービスにアクセスするための機器のセキュリティを確保することに単独で責任を負うものとします。
                      したがって、お客様は、合法か非合法かにかかわらず、アクセスコードを使用して、またはお客様のユーザーアカウントを通じて発生したすべての行為または不作為について、
                      単独かつ完全に責任を負うものとします。
                    </p>
                    <p>
                      お客様は、アクセスコードやユーザーアカウントが不正に使用された場合、またはその他のセキュリティ違反があった場合、直ちに当社に報告しなければなりません。
                      さらにお客様は、ご自身のユーザーアカウント、データ、または当社に提供したその他の情報やコンテンツへの不正アクセスのリスクをすべて受け入れることに同意します。
                      当社は、アクセスコードの一致を確認した場合、当該アクセスコードの保有者として登録されたユーザーが本サービスを利用したものとみなします。
                    </p>
                  </li>
                  <li>
                    契約期間、解約および停止
                    <p>
                      当社は、事前に通知することなく、独自の裁量により、お客様の本サービスへのアクセスまたは使用の権利を終了または停止し、
                      お客様による今後の本サービスへのアクセスまたは使用を遮断する権利を留保します。これには、
                      本サービスの不正な使用またはアクセスがあったと判断された場合、本サービスが適用される法域の法律に違反する方法で使用またはアクセスされた場合、
                      ユーザーが本サービスに関連する料金を当社に支払うべき時に支払わ ない場合、
                      ユーザーが本規約のいずれかに違反した場合および/またはユーザーが本サービスを上記の許可された目的以外の目的で使用した場合が含まれますが、
                      これらに限定されません。
                    </p>
                    <p>誤解を避けるために申し上げますが、ユーザーアカウントの終了または停止の場合、当社はユーザーに次の事項を提供する義務を負わないものとします。</p>
                    <p>(i) あらゆる調査の終了日</p>
                    <p>(ii) 停止がいつ解除されるかについての保証</p>
                    <p>
                      終了時には、ユーザーアカウントは直ちに取り消され、ユーザーはそのユーザーアカウントや本サービスにアクセスできなくなります。
                      また、お客様のユーザーアカウントに関連する、または本サービスを通じて提供されるすべてのコンテンツおよび情報は、当社によって直ちに破棄または削除される場合があります。
                    </p>
                  </li>
                  <li>
                    さらに、ユーザーが本規約のいずれかの条項に違反した場合、ユーザーは、
                    当社が差止命令による救済を申請しおよび／または当社が必要と考えるその他の措置をユーザーに対して講じることに同意するものとします。
                  </li>
                  <li>
                    本規約のうち、本項 4（第 4.4 項）、第 7 項（知的財産権の所有）、第 8 項（個人情報）、第11 項（保証の免責）、第 13 項（責任の制限）
                    、第 14 項（補償）、第 17 項（権利放棄）、および条項の性質に鑑み当然に存続すべき規定は、ユーザーアカウントの消滅または本契約が解除された後も存続します。これらの段落は、
                    法律で認められる最大限の範囲で、本規約の終了後も存続するものとします。
                  </li>
                  <li>
                    当社は、適用法で認められている最大限の範囲で、お客様に通知することなく、またお客様の許可を得ることなく、当社のサービス、ウェブサイト、
                    チャンネルに関するお客様の活動を閲覧、監視、記録する権利を有します。監視、レビュー、記録によって得られた情報は、政府や法執行機関が、当社のウェブサイト、
                    アプリ、プラットフォームにおける犯罪行為の可能性の調査や訴追に関連して調査することもあります。また、当社は、かかる情報の提供を求めるすべての適用法および裁判所命令を遵守します。
                  </li>
                </ul>
              </li>
              <li>
                ユーザーコンテンツ
                <ul>
                  <li>
                    お客様は、お客様が本サービスに関連して利用可能にしたすべての情報、データ、テキスト、音声、写真、グラフィック、ビデオ、メッセージ、投稿、
                    タグ、ソフトウェア、その他の素材（以下「ユーザーコンテンツ」といいます）を、公開投稿、非公開送信、または第三者を介して送信したかどうかにかかわらず、
                    所有しているか、または公開するために必要かつ有効なライセンス、権利、同意、許可を得ていることを断言、表明、保証するものとします。
                  </li>
                  <li>
                    お客様は、当社に対し、お客様が投稿したユーザーコンテンツ、または本サービスに関連して投稿したユーザーコンテンツを使用するための非独占的、
                    譲渡可能、サブライセンス可能、ロイヤリティフリー、かつ世界的なライセンスを付与します。お客様のユーザーコンテンツを使用する当社の権利は、
                    お客様のユーザーアカウントが削除または停止された後も存続します。
                  </li>
                  <li>
                    お客様は、お客様が本サービスを介して投稿、アップロード、電子メール送信、その他の方法で利用可能にしたすべてのユーザーコンテンツについて全責任を負います。当社は、本サー
                    ビスに投稿されたユーザーコンテンツを監視することができますが、その義務はありません。当社は、いつでも、いかなる理由でも、本規約に違反するユーザーコンテンツ、
                    またはその他の攻撃的もしくは好ましくないユーザーコンテンツを選別、監視、審査、拒否または削除することができます。お客様は、本サービスを利用することにより、
                    攻撃的、わいせつ、好ましくないユーザーコンテンツにさらされる可能性があることを理解しており、当社は、本サービスを通じて利用可能なユーザーコンテンツの使用から生じるいかなる損失または損害に対しても、
                    一切責任を負いません。
                  </li>
                  <li>
                    当社は、ユーザーが投稿または提供したユーザーコンテンツを保証するものではなく、ユーザーが提供したユーザーコンテンツは、ヘイトスピーチの防止、わいせつ、
                    ポルノ、下品なコンテンツ、または一般的な公共の保護を目的とした主題に関連するものを含む、現行の法律および規制の対象となります。
                  </li>
                  <li>
                    お客様が本サービスをご利用になる際には、お客様が投稿・通信するユーザーコンテンツおよび本サービスをご利用になる際に、お客様がコミュニティガイドラインを遵守することが条件となります。
                    お客様は、本サービスを介したお客様の投稿および／または通信が、以下のいずれかに該当するものを含まないことに同意するものとします。
                    <p className="pl-3">(i) ポルノ、性的に露骨または卑猥なもの</p>
                    <p className="pl-3">(ii) ヘイトスピーチ、偏見、または差別</p>
                    <p className="pl-3">
                      (iii) 未成年者または危険な状態にある個人の福祉を脅かす、
                      またはそのような個人を危険にさらす可能性のある行動を助長するとみなされるもの
                    </p>
                    <p className="pl-3">(iv) スパム、スパムメール、またはバルクまたはマスマーケティングコミュニケーションを構成するもの</p>
                    <p className="pl-3">(v) 虚偽、誤解を招く、詐欺的または欺瞞的なもの</p>
                  </li>
                  <li>
                    フィードバック
                    <p>
                      お客様は、当社および/またはサービスに関するあらゆる資料(質問、コメント、フィードバック、提案、アイデア、計画、メモ、図面、オリジナルまたは創造的な資料・
                      ネタ、その他の情報を含むがこれらに限定されない、以下、総称して「フィードバック」)を、電子メール、ウェブサイト、チャンネルへの投稿、その他の方法で提供した場合、
                      当該フィードバックは非機密情報であり、当社の所有する財産となることを認め、同意したものとします。
                      当社は、すべての知的財産権を含む独占的な権利を有し、商業目的か否かを問わず、お客様への謝辞や報酬なしに、このようなフィードバックを無制限に使用し、普及させる権利を有するものとします。
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                支払い
                <ul>
                  <li>
                    ユーザーアカウントを登録すると、お客様は、随時、無料で提供されるサービスを利用することができます。
                    他のサービスへのさらなるアクセスには、そのような支払いまたは購読を行う際に、指定された料金および当社が提供するその他の条件の支払いが必要となる場合があります。
                    料金や機能は、お客様が選択する製品によって異なります。お客様は、ご自身のユーザーアカウントに関連して発生したかかる手数料または料金を適宜支払うことに同意します。
                    当社は、本規約の修正により、合理的な通知を行った上で、いつでも料金を増額したり、新たな料金を導入したりする権利を有します。
                  </li>
                  <li>
                    支払い条件
                    <p>
                      請求された関連料金は返金不可であり、課税当局によって課されるすべての適用される税金、賦課金、または関税（以下あわせて「税金」といいます）を含んでおらず、
                      お客様はかかるすべての税金の支払いに責任を負うものとします。
                    </p>
                  </li>
                  <li>別段の定めがない限り、すべての料金は、月単位または年単位で前払いされるものとします。</li>
                  <li>別段の定めがない限り、お客様は、適用される税金を支払う義務があります。</li>
                  <li>別段の定めがない限り、月額プランまたは会員プランの変更は、次の請求サイクルで有効になります。</li>
                  <li>
                    お客様のサブスクリプションは、最初に選択されたサブスクリプション期間と同じ期間、現行のサブスクリプションレートで、お客様が最初に選択された支払方法により、
                    連続した更新期間に自動的に延長されます。
                  </li>
                  <li>
                    返金方針
                    <p>
                      お客様が本サービスに満足できないと判断された場合、当社が独自の判断で返金を検討する前に、お客様のフィードバックを通じて書面による説明が必要となります。
                      それぞれのケースは、事案や事情によって個別に評価されます。
                    </p>
                  </li>
                  <li>
                    お客様が当社に支払情報を提供した場合、お客様は、当社（および関連する第三者のサービスプロバイダー、支払カードネットワーク、支払処理業者）
                    がお客様の支払情報を受領し、保管し、暗号化することに同意し、権限を付与するものとします。
                  </li>
                  <li>
                    本規約にかかわらず、当社は、事前に通知することなく、独自の裁量により、上記第 4.4 項（契約期間、解約・停止）に従って、お客様の本サービスへのアクセスまたは使用の権利を解約または停止し、
                    お客様による今後の本サービスへのアクセスまたは使用を遮断する権利を留保します。
                  </li>
                </ul>
              </li>
              <li>
                知的財産権の帰属
                <ul>
                  <li>
                    当社は、本サービスのユーザーとして、本規約に従い、ユーザーアカウントを通じて本サービスを使用、インストール、アクセス、操作、実行するための限定的、
                    非独占的、譲渡不能、サブライセンス不能、取消可能な世界的ライセンスを、ユーザーの私的利用のためにのみ付与し、商業的利用、再販、または他の個人や組織のために、
                    および組織を代表して使用することはできません。
                  </li>
                  <li>
                    お客様は、本サービスおよび関連するすべての知的財産権が当社（または該当する場合はそのライセンサー）に帰属し、
                    適用される著作権法によって保護されていることを認め、これに同意するものとします。
                  </li>
                  <li>
                    本規約に明示的に記載されている場合を除き、当社は、本サービスに関するいかなる権利またはライセンス（本サービスの使用、
                    複製、出版、表示、編集、送信、放送、その他の利用を行う権利を含むがこれに限定されない。）も明示的または黙示的にお客様に付与しません。
                    本規約や本サービスの利用によって、いかなる所有権もユーザーに譲渡または付与されることはありません。
                  </li>
                  <li>
                    当社は、本サービスに関する知的財産権を含むすべての権利を留保します。これらの権利は、開発または存在する特許、商標、著作権、企業秘密、
                    知的財産権および工業所有権を含み、世界中のあらゆる形態のメディアにおいて、お客様に対する義務を負うことなく、当社の独自の裁量で使用および処分するために使用されます。
                    お客様は、「Zenyum」、「Zenyum治療」、「Zenyum Invisible Braces」の名称や、当社が所有または管理するその他の商標を、登録の有無にかかわらず、
                    当社の書面による事前承認なしに、いかなる方法でも使用することはできません。
                  </li>
                </ul>
              </li>
              <li>
                個人情報
                <ul>
                  <li>当社がお客様から提供された、またはお客様から収集したすべての個人情報（個人情報保護法の定義による。）は、当社のデータ保護およびプライバシーポリシーに基づき、機密情報として取り扱われます。</li>
                  <li>本サービスは、お客様の矯正治療等に関する情報を取扱うため、お客様は本サービスを利用する前に、必ずプライバシーポリシーをお読みいただき、内容に同意していただく必要があります。</li>
                </ul>
              </li>
              <li>
                第三者のリンク
                <ul>
                  <li>
                    本ウェブサイトには、第三者が運営するプロパティ、サイト、製品へのハイパーリンクが掲載されている場合があります。第三者のサイトへのアクセスは、お客様の責任において行われるものとし、
                    お客様は、当社ではなく当該第三者と直接契約することを認識するものとします。このようなリンクは利便性のために提供されているものであり、このようなリンクが含まれていても、
                    第三者の製品やサービスを推奨または保証するものではありません。お客様は、本ウェブサイトに掲載されている第三者の製品またはサービスと交流したり、利用したりする義務はありません。
                  </li>
                  <li>
                    当社は、かかる第三者の製品またはサービスの信頼性について責任を負うものではなく、また、第三者の情報またはその他の資料について責任を負うものでもありません。
                    当社は、お客様が本ウェブサイトを通じて、またはその他の方法で第三者と取引した結果、お客様が被ったいかなる損失または損害についても責任を負いません。
                  </li>
                  <li>
                    お客様は、他者の権利を侵害するような方法で第三者の資料を使用しないこと、およびお客様によるそのような使用に対して当社が一切の責任を負わないことに同意します。
                    ただし、そのハイパーリンクが、当社またはチャンネルやウェブサイトの一部を虚偽、誤解を招くような、軽蔑的な、または名誉を毀損するような形で描写していないこと、
                    さらにそのリンク先がアダルトや違法な素材、攻撃的、嫌がらせ的、またはその他の好ましくない素材を含んでいないことが条件となります。この限定的な権利は、当社の独自の判断により、
                    いつでも取り消すことができるものとします。
                  </li>
                </ul>
              </li>
              <li>
                リスクの想定
                <ul>
                  <li>
                    当社は、安全で信頼性の高いウェブサイト、アプリおよびプラットフォームの構築に努めていますが、
                    お客様が本サービスにアクセスおよび／または利用する過程で送受信される通信や素材の機密性は保証されないことをご了承ください。したがって、当社は、インターネットを
                    介して送信されるいかなる情報のセキュリティについても責任を負いません。当社は、インターネット、
                    ネットワーク、またはホスティングサービスの中断または不作為について責任を負いません。お客様は、本サービスを利用する際の唯一かつ完全なリスクを負うものとします。
                  </li>
                </ul>
              </li>
              <li>
                保証に関する免責事項（非保証）
                <ul>
                  <li>
                    <p>
                      ウェブサイトおよびチャンネルで提供される情報は、情報提供のみを目的としたものであり、網羅的なものではありません。これらの情報は、当社が「現状有姿」かつ
                      「入手可能な範囲」で提供するものであり、いかなる明示的または黙示的な保証もありません。当社は、本サービスの性能、中断のない安全な利用可能性について、
                      いかなる保証も行いません。当社は、本サービスに関連する明示的または黙示的な保証（本ウェブサイトおよび本ウェブサイトに含まれる情報、コンテンツ、資料に関する、
                      商品性、特定目的への適合性、権原および権利を侵害していないことの黙示的保証を含むがこれに限定されない。）
                      を一切行いません。当社は、これらの情報が正確であること、完全であること、信頼できること、最新であること、または誤りがないことを表明または保証しません。
                    </p>
                    <p>
                      また、当社は、情報の誤りが修正されることを保証しません。当社は、お客様の本サービスへのアクセスおよび利用を安全にするよう努めていますが、
                      本ウェブサイトまたはそのサーバーに欠陥、ウィルス、マルチウェア、その他の有害な要素がないことを表明または保証することはできませんし、
                      いたしません。当社は、方法の如何を問わず、ユーザーが本サービスの使用、変更、寄稿、複写、配布、またはダウンロードによって被ったいかなる損害に対しても責任を負いません。
                    </p>
                  </li>
                  <li>
                    当社は、本サービスの一部としてお客様に提供される資料が、特定の場所での使用に適切であること、または使用可能であることを表明または保証するものではありません。また、
                    当社サービスの内容のいずれかに違法である地域からアクセスをすることは禁止されています。お客様がそのような地域から本サービスにアクセスすることを選択した場合、
                    お客様は自らの意思でこれを行い、適用される地域の法律、規則、規制を遵守する責任を負います。当社は、いつでも、当社の独自の裁量により、本サービスの全部または一部の利用を、
                    当社が選択した人物、地理的地域、または司法権に限定することができます。お客様は、当社のウェブサイト、アプリ、またはプラットフォームに関して、当社または当社の従業員、
                    代表者、または代理人が口頭または書面で行った情報または助言は、当該情報または助言が書面による合意によって本規約に組み込まれていない限り、表明または保証を構成しないことに同意し、了承します。
                  </li>
                  <li>
                    <p>
                      本サービスの下で提供されるいかなる情報も、その情報の原典を参照することによって完全に適切なものとなり、お客様は、
                      かかる原典を参照して適格性を認識し、参考にする必要があります。また、かかる記述または情報は、医療、歯科、
                      または健康の専門家からの専門的な意見または助言を構成するものではなく、またそのような意見または助言に相当するものでもなく、
                      その他、法律、ビジネス、または税務に関する意見または助言を構成するものでもありません。
                      <p>
                        当社は、信頼できると思われる情報源から情報を入手していますが、当社は監査を行わず、当社が使用する情報についてデューデリジェンスや独自の検証・確認を行う義務を負いませ
                        ん。当社は、本サービスの情報源として使用するいかなる情報についても、その正確性、妥当性、正しさについて、明示的にも黙示的にも保証することはできず、一切の責任を負いません。
                        当社は、当社のウェブサイトやチャンネルで利用可能なサービスや情報の真実性、信頼性、完全性について責任を負うことはできず、また責任を負いません。私たちは、本サービスの提供後、
                        いかなる情報も更新する義務を負いません。当社は、第三者が当社のウェブサイト、アプリ、プラットフォーム上で作成または表示した意見、アドバイス、情報、声明を支持せず、責任を負いません。
                      </p>
                    </p>
                  </li>
                  <li>
                    お客様は、アプリケーションまたは本サービスに関連して使用されるデータおよび／または機器の適切な保護とバックアップを確保することについて単独で責任を負うものとし、
                    お客様は、本ウェブサイトまたは本サービスの使用に起因するデータの損失、再実行時間、不正確な出力、作業の遅延、または利益の損失について、当社に対して請求しないものとします。
                  </li>
                  <li>
                    当社は、以下のいずれかに起因し、関連し、または関連するすべてのおよびすべての責任を明示的に否認します。
                    <p className="pl-3">インターネットまたは接続性の中断または遅延。</p>
                    <p className="pl-3">お客様または第三者のデータ、機器、ネットワーク、サーバー、アプリケーション、プロパ</p>
                    <p className="pl-3">ティ、ケーブリング、システム、設備または装置。</p>
                    <p className="pl-3">本サービスの定期メンテナンスまたはその他の変更。</p>
                    <p className="pl-3">お客様または第三者による作為または不作為。</p>
                    <p className="pl-3">本契約で認められていない本サービスの使用。</p>
                    <p className="pl-3">当社以外の個人または法人による本サービスの変更。</p>
                  </li>
                </ul>
              </li>
              <li>
                不可抗力/不測の事態
                <ul>
                  <li>
                    いずれの当事者も、本規約に基づく履行の不履行または遅延（本規約に基づき支払うべき金銭の支払いの遅延を除く）が、天災、政府の規制、テロ行為、自然災害、戦争、
                    暴動、その他の原因によって関連して関連して引き起こされた場合、その責任を負わないものとします。ただし、非責任の主張の条件として、困難を経験している当事者は、
                    依拠している原因の発生後に、詳細を記載した書面による迅速な通知を相手側に行うものとします。履行義務が果たされる予定の期日は、それに応じて、生じた遅延により失われた時間に相当する期間延長されます。
                  </li>
                  <li>
                    上記の一般性を制限することなく、お客様は、本サービスが、メンテナンス、サービス、ユーザーの活動、ユーザーのアクセス、接続性などに起因して、
                    時として中断、遅延、ラグタイムが発生することを認識し、これに同意するものとします。
                  </li>
                  <li>
                    当社は、お客様に事前に通知することなく、本サービスに含まれるすべてのコンテンツをいつでも変更する権利を有します。製品、サービス、プロセス、
                    その他の情報を、商号、商標、製造者、供給者、またはその他の方法で参照することは、当社がそれらを保証、後援、推奨することを意味するものではなく、またそれらとの関係を示唆するものでもありません。
                  </li>
                  <li>
                    製品保証
                    <p>
                      当社は、Zenyum Invisible Braces（透明な歯列矯正具）が意図された用途に適切に使用された場合、材料および製造上の欠陥がないことを保証します。この保証は、Zenyum 治療
                      の有効期限で終了します。本項に定める場合を除き、当社は、Zenyum 治療オプションおよび／またはその他の製品・
                      サービス、あるいはこれらの治療オプションおよび／または製品による治療の結果について、明示的、黙示的、
                      法定的またはその他のいかなる種類の保証も行わないものとします。当社は、デザイン、商品性、特定目的への適合性、権利を侵害していないこと、およびその他の黙示的な保証をすべて放棄します。

                    </p>
                    <p>
                      Zenyum Invisible Braces（透明な歯列矯正具）が、お客様に提供された所定の歯科治療計画および使用ガイドラインに従っ
                      て使用されなかった場合、誤用、改変、または他の（許可されていない）
                      第三者製品と組み合わせて使用された場合には、本項に定める保証は無効であり、
                      適用されません。また、Zenyum Invisible Braces（透明な歯列矯正具）を使用した治療の結果や、
                      Zenyum 製品やサービスと第三者の製品との組み合わせについては、いかなる保証も行われません。
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                責任の制限
                <ul>
                  <li>
                    当社、当社の取締役、従業員および代理人は、本サービスの使用または使用できないこと、本サービスに含まれる素材やコンテンツ、または本サービスを通じてアクセスされる素材に起因する、
                    または何らかの形で関連する、使用損失、利益損失、データ損失を含むがこれに限定されない、直接的、間接的、特別なまたは結果的な損害、またはその他のあらゆる種類の損害について、
                    契約、不法行為（過失を含むがこれに限定されない）、またはその他の行為にかかわらず、一切の責任を負いません。これには、天災地変、通信障害、盗難、破壊、または当社の記録、
                    プログラムもしくはサービスへの不正アクセスに起因するか否かを問わず、当社から入手した情報に依存したことに起因する損害、または、ファイルもしくは電子メールの誤記、脱落、
                    中断、削除、エラー、欠陥、ウィルス、操作もしくは送信の遅延、またはパフォーマンスの不備に起因する損害が含まれますが、これらに限定されません。
                    ただし、本契約が消費者契約法その他の強行法規の適用を受ける場合を除きます。
                  </li>
                  <li>
                    契約、保証、不法行為（能動的、受動的、積極的か否かを問わず、過失を含む）、製造物責任、厳格責任（無過失責任）、その他本サービスの使用または使用できないことに起因する、
                    当社、役員、代理人、代表者、従業員、パートナー、ライセンサーの責任総額は、本サービスへのアクセスまたは使用のためにお客様が当社に支払った対価（もしあれば）を超えないものとします。
                  </li>
                  <li>
                    当社は、自己の費用で、お客様が補償の対象としている事項について、排他的な防御および管理を行う権利を留保します。この場合、お客様は、当社が利用可能な防御を主張する際に協力することに同意します。
                  </li>
                </ul>
              </li>
              <li>
                補償
                <ul>
                  <li>
                    お客様は、以下のいずれかに起因または関連して、当社およびその関連会社ならびにその役員、代理人、代表者、従業員、
                    パートナーおよびライセンサーが被る第三者からのすべての請求、訴訟、行為、手続き（正式または非公式）、調査、判決、欠陥、損害、和解、負債、および法的その他の費用から、
                    当社およびその関連会社ならびにその役員、代理人、代表者、従業員、パートナーおよびライセンサーを補償し、防御し、免責することに同意します。
                    <p className="pl-3">お客様による本規約または適用法の違反または侵害。</p>
                    <p className="pl-3">お客様の重大な過失または故意の違法行為。</p>
                    <p className="pl-3">
                      お客様が当社に提供した情報やデータ、またはそのユーザーコンテンツに起因する一切の責任（侵害、所有権、
                      名誉毀損、誹謗中傷、わいせつ性の主張を含む）①お客様またはお客様がアクセスを提供した他者による本サービスおよびアクセスコードの使用。
                    </p>
                  </li>
                  <li>
                    当社は、自己の費用で、お客様が補償の対象としている事項について、排他的な防御および管理を引き受ける権利を留保します。
                    この場合、お客様は、当社が利用可能な防御を主張することに協力することに同意します。
                  </li>
                </ul>
              </li>
              <li>
                分離可能性
                <ul>
                  <li>
                    本規約のいずれかの条項が法的強制力を持たないと宣言された場合でも、本規約の残りの部分は完全に効力を持ち続け、
                    法的強制力を持たない条項は、適用される法律の要件を満たすために必要な範囲で修正されたものとみなされますが、その一方で、
                    意図された効果、範囲および経済的効果は、法律で認められる最大限の範囲で維持されます。
                  </li>
                </ul>
              </li>
              <li>
                使用されるキャプション
                <ul>
                  <li>
                    本規約のキャプション（表題・見出し）およびセクションの見出しは、参照の便宜を図るためのものであり、
                    本規約のいかなる条項の意味または解釈をも制限または影響するものではありません。
                  </li>
                </ul>
              </li>
              <li>
                契約上の地位の譲渡等
                <ul>
                  <li>
                    本規約およびお客様の権利または義務は、当社の書面による事前の同意なしに、お客様が譲渡または移転することはできません。
                    当社は、いつでも本規約を譲渡または変更する権利を有し、またその権利を留保し、そのような譲渡または変更についてお客様に通知するものとします。
                  </li>
                </ul>
              </li>
              <li>
                権利放棄
                <ul>
                  <li>
                    書面による明示的な権利放棄を除き、いずれの当事者の行為も、本規約のいずれかの条項を放棄したものと解釈することはできません。
                    一方の当事者がその権利または救済手段の行使を遅らせたとしても、かかる権利または救済手段を放棄したことにはならず、また、一方の当事者がかかる権利または救済手段を単独または部分的に行使したとしても、
                    かかる権利または救済手段の他のまたは今後の行使を妨げるものではありません。ある時点での権利または救済措置の放棄は、他の時点での権利または救済措置の禁止または放棄とは解釈されません。
                  </li>
                </ul>
              </li>
              <li>
                完全合意および優先事項
                <ul>
                  <li>
                    プライバシーポリシー(zenyum.com/privacy-policy)の条件は、参照することにより、その全体が本規約に組み込まれます。
                  </li>
                  <li>本規約とプライバシーポリシーの間に矛盾が生じた場合は、以下のものが優先されます（ガバナンスの優先順位が最初に記載され、当社に最も有利な保護を与えるように解釈されます）。</li>
                  <li>
                    本規約は、その主題に関するお客様と当社との間の完全な合意を構成するものであり、口頭か書面かを問わず、他のすべての合意、コミュニケーション、理解、交渉、および話し合い、
                    あるいは両者の間の取引の過程に優先します。本サービスへのアクセスまたは使用を通じて、お客様が第三者の製品またはサービスを利用または取得する場合、
                    お客様はさらに当該第三者の規約に従うことになりますが、本規約は、お客様と当該第三者との法的関係に影響を与えないものとします。
                  </li>
                </ul>
              </li>
              <li>
                準拠法および管轄裁判所
                <ul>
                  <li>
                    本規約は、抵触法の規定にかかわらず、日本の法律に準拠し、これに基づいて解釈され、これを執行するものとします。
                    両当事者は、いかなる紛争、請求、意見の相違、質問または問題も、誠意ある交渉を通じて直接解決するために最善の努力を払うものとし、
                    これはいずれかの当事者がいかなる法的措置を開始する前提となります。
                  </li>
                  <li>
                    本規約およびサービス利用契約の準拠法は日本法とします。
                  </li>
                  <li>
                    本規約またはサービス利用契約に起因し、または関連する一切の紛争については、訴額によって東京簡易裁判所または東京地方裁判所を第一審の専属的合意管轄裁判所とします。
                  </li>
                </ul>
              </li>
              <li>
                通知、サポート、質問
                <ul>
                  <li>
                    本規約に基づいて、または法律に基づいて必要とされる、または許可される通知、要求、同意、承認は、書面であれば十分であり、
                    お客様の場合は、お客様が提供された関連住所に電子メールまたは書留郵便で送付され、当社の場合は、以下の住所に送付されるものとします。
                  </li>
                </ul>
                <p>
                  電子メールアドレス :
                  <a href="mailto:smile.japan@zenyum.com">smile.japan@zenyum.com</a>
                </p>
                <p>住所：東京都江東区有明 3 丁目 7-11 有明パークビル 11 階</p>
                <br />
                <p>制定日：令和 3 年 10 月 5 日</p>
              </li>
            </ol>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
